import * as user from './user';
import * as home from './home';
import * as course from './course';
import * as knowledge from './knowledge';
import * as live from './live';
import * as train from './train';
import * as qst from './questionnaire';
import * as exam from './exam';
import * as tag from './tag';
import * as lecturer from './lecturer';
import * as integral from './integral';
import * as message from './message';
import * as knowpoint from './knowpoint';
import * as favorites from './favorites';
import * as likes from './likes';
import * as learningmap from './learningmap';
import * as certificate from './certificate';
import * as topic from './topic';
import * as shitu from './shitu';
import * as userknowledge from './userknowledge';

// 导出接口
export default {
  user,
  home,
  course,
  knowledge,
  live,
  train,
  qst,
  exam,
  tag,
  lecturer,
  integral,
  message,
  knowpoint,
  favorites,
  likes,
  learningmap,
  certificate,
  topic,
  shitu,
  userknowledge,
};
